import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/')({
  validateSearch: zodValidator(ImportCsvSearchSchema)
});